<template>
    <b-form-datepicker 
        :id="id" 
        :class="classes"
        :locale="locale"
        v-bind="labels[locale] || {}"
        :min="min"
        :max="max"
        v-model="valueInterface"
    ></b-form-datepicker>
</template>

<script>
    export default {
        props: {
            id: String,
            classes: String,
            locale: String,
            value: String,
            min: String,
            max: String,
            placeholder: String
        },
        data(){
            return{
                labels: {
                    it: {
                        labelPrevDecade: 'Decennio precedente',
                        labelPrevYear: 'Anno precedente',
                        labelPrevMonth: 'Mese precedente',
                        labelCurrentMonth: 'Mese corrente',
                        labelNextMonth: 'Mese successivo',
                        labelNextYear: 'Anno successivo',
                        labelNextDecade: 'Decennio successivo',
                        labelToday: 'Oggi',
                        labelSelected: 'Data selezionata',
                        labelNoDateSelected: this.locale=='it' && this.placeholder ? this.placeholder : 'Nessuna data selezionata',
                        labelCalendar: 'Calendario',
                        labelNav: 'Navigazione nel calendario',
                        labelHelp: 'Usa i tasti freccia per scegliere la data nel calendario'
                    }
                }
            }
        },
        computed:{
            valueInterface: {
                get() {
                    return this.value
                },
                set(val) {
                    this.$emit('getValue', val)
                }
            }
        }
    }
</script>

<style scoped lang="scss">
</style>
